import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, XAxis } from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/frontend/components/ui/card";
import type { ChartConfig } from "@/frontend/components/ui/chart";
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/frontend/components/ui/chart";

type ChartData = {
  date: string;
  csm: number;
  sales: number;
};

const chartConfig = {
  csm: {
    label: "CSM",
    color: "var(--chart-1)",
  },
  sales: {
    label: "SALES",
    color: "var(--chart-2)",
  },
} satisfies ChartConfig;

export function MessageChart() {
  const [chartData, setChartData] = useState<ChartData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/chart/messages")
      .then((res) => res.json())
      .then((data) => {
        setChartData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch chart data:", err);
        setLoading(false);
      });
  }, []);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
    }).format(date);
  };

  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Messages - Last 14 Days</CardTitle>
          <CardDescription>Loading...</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Messages - Last 14 Days</CardTitle>
        <CardDescription>Daily message count by team</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig}>
          <BarChart accessibilityLayer data={chartData}>
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="date"
              tickLine={false}
              tickMargin={10}
              axisLine={false}
              tickFormatter={formatDate}
            />
            <ChartTooltip content={(props: any) => <ChartTooltipContent {...props} hideLabel />} />
            <ChartLegend
              content={(props: any) => (
                <ChartLegendContent
                  {...props}
                  className="mt-6 text-base font-semibold [&>div>div>div]:h-3 [&>div>div>div]:w-3"
                />
              )}
            />
            <Bar
              dataKey="csm"
              stackId="a"
              fill="var(--color-csm)"
              radius={[0, 0, 4, 4]}
            />
            <Bar
              dataKey="sales"
              stackId="a"
              fill="var(--color-sales)"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
